import helperA11y       from 'shared/mixins/helper-a11y';
import callMe           from 'shared/modules/call-me/call-me';
import feedback         from '../../../elements/feedback/feedback';
import tabstrip         from 'shared/elements/tabstrip/tabstrip';
import videoTrigger   from 'shared/elements/video-modal/video-modal';
import Cookies          from 'js-cookie';

const customerTypeCookieName = 'ge-cs-type';

/**
 * Group lines into paragraphs: empty line = new paragraph, consecutive non-empty = one paragraph with <br /> between.
 * Returns array of { paragraphHtml } for the answer template.
 */
function textsToParagraphs(texts) {
    if (!texts || !Array.isArray(texts)) return [];
    const groups = [];
    let current = [];
    for (const line of texts) {
        const trimmed = (line == null ? '' : String(line)).trim();
        if (trimmed === '') {
            if (current.length) {
                groups.push(current);
                current = [];
            }
        } else {
            current.push(trimmed);
        }
    }
    if (current.length) groups.push(current);
    const escapeHtml = (s) => {
        const div = document.createElement('div');
        div.textContent = s;
        return div.innerHTML;
    };
    const result = groups.map((lines) => ({
        paragraphHtml: lines.map(escapeHtml).join('<br />')
    }));
    result.forEach((p, i) => { p.isLast = i === result.length - 1; });
    return result;
}

function addParagraphsToAnswerContext(ctx) {
    if (!ctx) return ctx;
    if (ctx.texts) {
        return { ...ctx, paragraphs: textsToParagraphs(ctx.texts) };
    }
    return ctx;
}

/**
 * FAQ Question
 * this is the implementation of each question in the
 * faq.
 */
function faqQuestion(el, faq, model, app, single) {

    const a11yHelper                = helperA11y(app);

    const $el = $(el);
    let $toggler, $answer;

    // if we're not in single mode.
    if (!single) {
        $toggler = $el.find('[data-js-faq-toggler]');
        $answer = $el.find('[data-js-faq-answer]');
        $toggler.click((evt) => {
            evt.preventDefault();
            toggle();
        });
    }

    let open = false;
    let answerRendered = false;

    /**
     *
     */
    const toggle = function() {
        open = !open;

        // update the url
        faq.setParams({
            question: open ? model.id : undefined,
        });
        // render the result
        if (!answerRendered) {
            render();
        }
        // log action
        if (open) {
            logView();
        }
    };

    /**
     *
     */
    const render = function() {
        model.baseUrl = faq.baseUrl;
        const modelForRender = {
            ...model,
            private: addParagraphsToAnswerContext(model.private),
            company: addParagraphsToAnswerContext(model.company)
        };

        // when someone opens a question we want to track in in the api.
        let content = faq.tmplQuestion.render(modelForRender, {
            answer: faq.tmplAnswer,
            contactPrivate: faq.tmplPrivateContact,
            contactCompany: faq.tmplCompanyContact,
            feedback: faq.tmplFeedback
        });

        let target = single ? $el : $answer;
        target.append(content);
        answerRendered = true;

        let feedbackEl = $el.find('[data-js-feedback]');
        feedback(feedbackEl[0],app);

        // we got a tabstrip.
        if (!model.sameAnswerForCompany) {
            let tabstripEl = $el.find('[data-js-faq-tabstrip]');
            let tabsInstance = tabstrip(tabstripEl[0], app);
            $(tabstripEl).on('tab:activated', customerTypePicked);

            // first try to figure out if the user has selected a type before.
            let customerType = parseInt(Cookies.get(customerTypeCookieName));
            if (customerType === 1) {
                $(tabstripEl).trigger('tab:activated', 1);
            }
        }

        // initialise any videos
        const $videoModal = $el.find('[data-video-id]')
        if ($videoModal.length) {
            videoTrigger($videoModal[0],app);
        }
        

        // reveal ally
        a11yHelper.show($el);
        $el.find('[name="feedback"]').attr('tabindex','-1').attr('aria-hidden','true');
        $el.find('[data-js-feedback-send]').attr('tabindex','-1').attr('aria-hidden','true');

        // did we have a call me object for either company or private...
        let hasPrivateCallMe = model.private && model.private.contact && model.private.contact.callMe;
        let hasCompanyCallMe = model.company && model.company.contact && model.company.contact.callMe;

        if (hasPrivateCallMe || hasCompanyCallMe) {
            // ... then wire them.
            $el.find('[data-js-call-me]').each((i, el) => {
                callMe(el, app);
            });
        }
    };

    const unbindEvents = function() {

    };

    /**
     * Tracks that a question has been viewed by making a call
     * to the api.
     */
    const logView = function() {

        let url = `${document.location.protocol}//${faq.baseUrl}/GeneralApi`;
        let data = {
            command: 'Qa-LogQuestionView',
            question: model.id
        };

        // find the category names associated with this question
        let   cats = [];
        const catLookupArray = app.faq.categories;
        if (model.categories && model.categories.length && catLookupArray) {
            model.categories.forEach((val1) => {
                const catActualId = val1;
                catLookupArray.forEach((val2) => {
                    const catLookupId = val2.id;
                    if (catActualId + '' === catLookupId + '') {
                        cats.push('[' + val2.name + ']');
                    }
                });
            });
            cats = cats.join('') + ': ';
        }

        // ga
        app.trigger('beacon',`faq-question-open,${cats}${model.headline.replace(',',' - ')}`);

        return $.ajax(url, { data });
    };

    /**
     * Whenever customer type was picked "Privat" or "Företag"
     * We store that so the future questions they open use the same.
     */
    const customerTypePicked = function(index) {
        // Note: we assume the order of the tabs are
        // 0 => private
        // 1 => company.
        Cookies.set(customerTypeCookieName, index, { expires: 365, path: '/' });
    };

    return {
        unbindEvents,
        render,
        logView
    };
}

export default faqQuestion;
